import api from "@/services/api"
import type { Pagination } from "@/types/pagination"
import type {
  ProfileId,
  ProfileRequest,
  ApprovalRequest,
  Permission,
  UserGroupExists
} from "@/types/profile"

export class ProfilesApi {
  public getUserProfiles = () => api.get("/api/v1/groups")

  public getProfiles = () => api.get(`/api/v1/groups`)

  public getGroups = () => api.get<UserGroupExists[]>(`/api/v1/groups`)

  public getProfile = (id: ProfileId) => api.get(`/api/v1/profiles/${id}`)

  public requestProfile = (data: ProfileRequest) =>
    api.post("/api/v1/profiles", data)

  public cancelRequestProfile = (id: ProfileId) =>
    api.patch(`/api/v1/profiles/${id}/cancel-request`)

  public getPermissions = () =>
    api.get<Pagination<Permission>>("/api/v1/permissions", {
      params: {
        page_size: 9999,
        page: 1
      }
    })

  public handleProfileApproval = (data: ApprovalRequest) =>
    api.patch(`/api/v1/profile_to_approve`, data)
}
